/*
 * West Coast Deals — eased momentum scrolling (Lenis)
 * Adds weighted, "glide" smooth scrolling site-wide.
 * - Respects prefers-reduced-motion (falls back to native scroll).
 * - Desktop pointers only; touch devices keep native scrolling.
 * - Leaves overlay scroll areas (cart drawer, mini-cart, modals, predictive
 *   search) on native scrolling so they never fight the page.
 * - Routes in-page anchor links (#...) through Lenis for smooth jumps.
 */
(function () {
  if (typeof Lenis === 'undefined') return;

  // Honor the OS "reduce motion" setting — no momentum for those users.
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceMotion.matches) return;

  // Touch devices already scroll natively (syncTouch is off below), so Lenis
  // changes nothing visible there while its rAF loop runs every frame — pure
  // main-thread cost on the devices least able to afford it.
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!finePointer.matches) return;

  var OVERLAY_SCROLLERS =
    '[data-lenis-prevent], .drawer-content, .mini-cart-content-inner, .modal-dialog, .predictive-search';

  var lenis = new Lenis({
    duration: 1.05,
    easing: function (t) {
      return Math.min(1, 1.001 - Math.pow(2, -10 * t));
    },
    smoothWheel: true,
    syncTouch: false, // keep mobile touch scrolling native (feels best on phones)
    wheelMultiplier: 1,
    prevent: function (node) {
      return !!(node && node.closest && node.closest(OVERLAY_SCROLLERS));
    }
  });

  // expose for other scripts / debugging
  window.lenis = lenis;

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  // Smooth in-page anchor links through Lenis
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href^="#"]');
    if (!link) return;
    var hash = link.getAttribute('href');
    if (!hash || hash.length < 2) return;
    var target = document.querySelector(hash);
    if (!target) return;
    e.preventDefault();
    lenis.scrollTo(target);
  });
})();
